var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccessCircleLarge = function SvgSuccessCircleLarge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30.08C23.7762 30.08 30.08 23.7762 30.08 16C30.08 8.22383 23.7762 1.92 16 1.92C8.22383 1.92 1.92 8.22383 1.92 16C1.92 23.7762 8.22383 30.08 16 30.08ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30.08C23.7762 30.08 30.08 23.7762 30.08 16C30.08 8.22383 23.7762 1.92 16 1.92C8.22383 1.92 1.92 8.22383 1.92 16C1.92 23.7762 8.22383 30.08 16 30.08ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99757 17.5543C8.74763 17.3043 8.74763 16.8991 8.99756 16.6492L9.4501 16.1966C9.70004 15.9467 10.1053 15.9467 10.3552 16.1966L14.1605 20.0018L22.7882 11.3742C23.0381 11.1242 23.4434 11.1242 23.6933 11.3742L24.1458 11.8267C24.3958 12.0767 24.3958 12.4819 24.1458 12.7318L14.1605 22.7171L8.99757 17.5543Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99757 17.5543C8.74763 17.3043 8.74763 16.8991 8.99756 16.6492L9.4501 16.1966C9.70004 15.9467 10.1053 15.9467 10.3552 16.1966L14.1605 20.0018L22.7882 11.3742C23.0381 11.1242 23.4434 11.1242 23.6933 11.3742L24.1458 11.8267C24.3958 12.0767 24.3958 12.4819 24.1458 12.7318L14.1605 22.7171L8.99757 17.5543Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessCircleLarge);
export { ForwardRef as ReactComponent };